import usePreference from "@hooks/usePreference";
import usePromotionBottomPromptVisibility from "@hooks/usePromotionBottomPromptVisibility";
import usePromotionStatus from "@hooks/usePromotionStatus";
import useSkinnerBoxStatus from "@hooks/useSkinnerBoxStatus";
import { useMemo } from "react";

/**
 * Hook to determine if user is eligible for FTD (First Time Deposit) gift.
 * This eligibility controls:
 * - FTDGiftTextButton visibility in CenterButton
 * - BalanceBadge deposit pulse animation
 *
 * User is eligible when:
 * - They are qualified for deposit gift box (isDepositGiftBoxQualified)
 * - They have no claimable promotions (!isAnyClaimable)
 * - PromotionBottomPrompt is not visible (!shouldShowPromotionPrompt)
 * - They haven't successfully submitted a topup in this session (!hasTopUpSuccessInSession)
 */
export default function useFTDEligibility() {
  const { isAnyClaimable } = usePromotionStatus();
  const { isDepositGiftBoxQualified } = useSkinnerBoxStatus();
  const { shouldShowPrompt: shouldShowPromotionPrompt } = usePromotionBottomPromptVisibility(isAnyClaimable ?? false);
  const { hasTopUpSuccessInSession } = usePreference();

  const isFTDEligible = useMemo(() => {
    return isDepositGiftBoxQualified && !isAnyClaimable && !shouldShowPromotionPrompt && !hasTopUpSuccessInSession;
  }, [isDepositGiftBoxQualified, isAnyClaimable, shouldShowPromotionPrompt, hasTopUpSuccessInSession]);

  return isFTDEligible;
}
